import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IRegistrationUser } from "../../models/IRegistrationUser";
import { ILoginUser } from "../../models/ILoginUser";
import { IUserProfile } from "../../models/IUserProfile";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://cinemaguide.skillbox.cc" }),
  tagTypes: ["User"],
  endpoints: (build) => ({
    registrationUser: build.mutation<IRegistrationUser, IRegistrationUser>({
      query: (user) => ({
        url: `/user`,
        method: "POST",
        body: user,
        credentials: "include",
      }),
    }),
    loginUser: build.mutation<ILoginUser, ILoginUser>({
      query: (user) => ({
        url: `/auth/login`,
        method: "POST",
        body: user,
        credentials: "include",
      }),
      invalidatesTags: ["User"],
    }),
    userProfile: build.query<IUserProfile, string>({
      query: (url) => ({
        url: url,
        credentials: "include",
      }),
      providesTags: ["User"],
    }),
    logoutUser: build.mutation<void, void>({
      query: () => ({
        url: `/auth/logout`,
        credentials: "include",
      }),
    }),
  }),
});
